const externalLinks = [
  {
    title: 'Qlik Dashboards',
    children: [
      {
        id: 1083,
        permission: 93,
        title: 'Recoup Dashboard',
        link: 'https://analytics.data-plarium.com/pdp/sense/app/ec9997b6-e079-48c3-899b-6bb96e635ff1/sheet/996cd8a1-ffde-4740-9daa-cfdd7b5411a9/state/analysis',
      },
    ],
  },
  {
    title: 'Reports',
    children: [
      {
        title: 'SKAN Model Stats',
        link: 'https://lookerstudio.google.com/reporting/e70ca567-4a6c-4c7a-b78b-c4d035173c2e/page/WN1mD',
      },
    ],
  },
];

export default externalLinks;
